import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import passwordResetSlice from './slices/passwordResetSlice';
import savedLocationsReducer from './slices/savedLocationsSlice';
import forecastSlice from './slices/forecastSlice';
import savedSpotsSlice from './slices/savedSpotsSlice'
import daylyForecastSlice from './slices/daylyForecastSlice'
import hourlyForecastSlice from './slices/hourlyForecastSlice'
import liveDataSlice from './slices/liveDataSlice';
import cookieAcceptanceSlice from './slices/cookieAcceptanceSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'savedLocations', 'forecast', 'savedSpots', 'dailyForecast', 'hourlyForecast', 'liveData', 'cookieAcceptance'],
};

const rootReducer = combineReducers({
  auth: authSlice,
  passwordReset: passwordResetSlice,
  savedLocations: savedLocationsReducer,
  savedSpots: savedSpotsSlice,
  forecast: forecastSlice,
  dailyForecast: daylyForecastSlice,
  hourlyForecast: hourlyForecastSlice,
  liveData: liveDataSlice,
  cookieAcceptance: cookieAcceptanceSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export const RootState = store.getState;
export const AppDispatch = store.dispatch;